/* eslint-disable */ /* eslint-disable no-debugger, no-console */
<template>
  <b-container class="form_container" style="text-align:unset;">
    <b-row>
      <b-col sx="12" offset="0" sm="4" offset-sm="4">
        <b-img class="logo" src="/img/MVP_Logo.png" alt="MVP Logo" width="350" style="width:100%;" />
      </b-col>
    </b-row>
    <form id="lassoForm" @submit.prevent="submitFormLasso">
            <b-row>
              <!-- <b-col lg="12" class="close_column">
                <p class="close" @click="hideModal">
                  <span>{x}</span> CLOSE
                </p>
              </b-col>-->
              <b-col sm="12" md="3">
                <!-- <b-form-group label="FIRST NAME*">
                  <b-form-input
                    id=""
                    v-model="form.firstname"
                    name=""
                    type="text"
                    class="form-control req"
                    required
                  />
                </b-form-group> -->
                <label for="firstName" class="form-label">FIRST NAME*</label>
                <input v-model="form.firstname"  name="" type="text" class="req form-control" required id="firstName">
              </b-col>
              <b-col sm="12" md="3">
                <label for="lastName" class="form-label">LAST NAME*</label>
                <input v-model="form.lastname" name="" type="text" class="req form-control" required id="lastName">
              </b-col>
              <b-col sm="12" md="6">
                <label for="howDidYouHearAboutUs" class="form-label">HOW DID YOU HEAR ABOUT US?*</label>
                  <select class="form-select" required v-model="form.howdidyouhearaboutus" name="" id="howDidYouHearAboutUs">
                    <option value="Fernbrook/MVP Website">
                      Fernbrook/MVP Website
                    </option>
                    <option value="Tiffany Park Homes/MVP Website">
                      Tiffany Park Homes/MVP Website
                    </option>
                    <option value="E-mail">
                      E-mail
                    </option>
                    <option value="Google Ad">
                      Google Ad
                    </option>
                    <option value="Social Media">
                      Social Media
                    </option>
                    <option value="Newspaper/Magazine">
                      Newspaper/Magazine
                    </option>
                    <option value="Billboard">
                      Billboard
                    </option>
                    <option value="A-frames/Signage">
                      A-frames/Signage
                    </option>
                    <option value="Realtor">
                      Realtor
                    </option>
                    <option value="Walk into a tent">
                      Walk into a tent
                    </option>
                    <option value="Friend">
                      Friend
                    </option>
                    <option value="Flyer">
                      Flyer
                    </option>
                    <option value="Other">
                      Other
                    </option>
                  </select>
              </b-col>
              <b-col sm="12" md="3">
                <label for="postalCode" class="form-label">POSTAL CODE*</label>
                <input v-model="form.postalcode" name="" type="text" class="req form-control" required id="postalCode">
              </b-col>
              <b-col sm="12" md="3">
                <label for="homePhone" class="form-label">HOME PHONE</label>
                <input v-model="form.homephone" name="" type="text" class="form-control req" numonly maxlength="12" id="homePhone">
              </b-col>
          <b-col sm="12" md="3">
            <label class="form-label d-flex align-items-start">ARE YOU AN AGENT?</label>
            <div class="d-flex align-items-start">
              <option :value="null" disabled />
              <div class="form-check m-1">
                <input
                  v-model="form.agent"
                  class="form-check-input"
                  type="radio"
                  id="yes"
                  name="flexRadioDefault"
                  :value="'Yes'"
                  required
                />
                <label class="form-check-label" for="yes">Yes</label>
              </div>
              <div class="form-check m-1">
                <input
                  v-model="form.agent"
                  class="form-check-input"
                  type="radio"
                  id="no"
                  name="flexRadioDefault"
                  :value="'No'"
                  required
                />
                <label class="form-check-label" for="no">No</label>
              </div>
            </div>
        </b-col>

      <b-col sm="12" md="3" v-if="form.agent === 'Yes'">
        <label>IF YES, WHAT IS THE NAME OF YOUR BROKERAGE</label>
        <input v-model="form.agentname" class="req form-control" required />
      </b-col>

        <b-col sm="12" md="3" v-else>
        </b-col>

        <b-col sm="12" md="3">
          <label>CELL PHONE</label>
            <input
              id=""
              v-model="form.cellphone"
              name=""
              type="text"
              class="form-control req numonly"
              maxlength="12"
            />
        </b-col>
        <b-col sm="12" md="3">
          <label>E-MAIL*</label>
            <input
              id=""
              v-model="form.email"
              type="email"
              class="form-control req js-cm-email-input"
              name=""
              required
            />
        </b-col>
        <b-col sm="12" md="3">
          <label>CITY*</label>
            <input
              id=""
              v-model="form.city"
              name=""
              type="text"
              class="form-control req numonly"
              maxlength="12"
            />
        </b-col>
        <b-col sm="12" md="6" class=" mt-2">
          <div class="mb-3 d-flex align-items-start flex-column">
            <label class="form-label">PREFERRED METHOD OF CONTACT</label>
            <div class="d-flex"> 
              <div class="form-check form-check-inline">
                <input
                  class="form-check-input"
                  type="radio"
                  id="homephone"
                  value="Home Phone"
                  v-model="form.methodOfContact"
                  :disabled="!form.homephone.length"
                  name="contactMethod"
                  required
                />
                <label class="form-check-label" for="homephone">Home Phone</label>
              </div>
              <div class="form-check form-check-inline">
                <input
                  class="form-check-input"
                  type="radio"
                  id="cellphone"
                  value="Cell Phone"
                  v-model="form.methodOfContact"
                  :disabled="!form.cellphone.length"
                  name="contactMethod"
                  required
                />
                <label class="form-check-label" for="cellphone">Cell Phone</label>
              </div>
              <div class="form-check form-check-inline">
                <input
                  class="form-check-input"
                  type="radio"
                  id="email"
                  value="Email"
                  v-model="form.methodOfContact"
                  name="contactMethod"
                  required
                />
                <label class="form-check-label" for="email">E-mail</label>
              </div>
            </div>
          </div>
        </b-col>

        <b-col sm="12" md="3" offset-md="3" class="buttonwrapper mt-2">
          <button
            type="submit"
            style="background-color:#F05B2D; color:white;"
            class="btn submitreq btn-block w-100"
          >SUBMIT</button>
        </b-col>
        <b-col md="12" class="text-center">
          <br>
          <p style="font-size: 80%;position:relative;display:inline-block;padding:0 15px" class="mandatory">
            * Mandatory Fields
          </p>
          <p style="font-size: 80%">
            By completing this Registration Form for Mapleview Park, I expressly
            provide my consent to receive electronic messages from Mapleview
            Park, retroactively, today and in the future and for any projects by
            the builders of Mapleview Park. I understand that I may withdraw my
            consent by unsubscribing at any time.
          </p>
          <p>
            <a to="/privacy-policy" target="_blank">
              <span style="color:#231f20;">Privacy Policy</span>
            </a>
          </p>
          <br>
          <b-row class="pb-2">
            <b-col cols="6" sm="2" offset-sm="4" class="pr-1">
              <a href="https://www.fernbrookhomes.com/" target="_blank">
                <b-img src="/img/fernbrook.png" alt="Fernbrook Homes" style="width:100%;" />
              </a>
            </b-col>
            <b-col cols="6" sm="2" class="pl-1">
              <a href="http://tiffanyparkhomes.com/" target="_blank">
                <b-img src="/img/tiffany.png" alt="Tiffany Park Homes" style="width:100%;" />
              </a>
            </b-col>
          </b-row>
          <!-- <b-img src="/img/zancor-light.png" fluid center alt="Zancor Homes" width="200" /> -->
        </b-col>
      </b-row>
    </form>

    <!-- Lasso form http://app.lassocrm.com/registrant_signup/test-->
    <form id="lasso-registration-form" method="post" action="https://app.lassocrm.com/registrant_signup/" style="display:none">
      <input type="hidden" name="registrationPageIdentifier" value="Online">
      <!-- <input type="hidden" name="domainAccountId" value="LAS-198363-08"> -->
      <input type="hidden" name="domainAccountId" value="">
      <input type="hidden" name="guid" value="">
      <input type="hidden" name="LassoUID" value="">
      <input type="hidden" name="ClientID" value="1470">
      <input type="hidden" name="ProjectID" value="15770">
      <input :value="form.firstname" type="text" name="FirstName">
      <input :value="form.lastname" type="text" name="LastName">
      <input :value="form.email" type="text" name="Emails[Primary]">
      <input :value="form.homephone" type="text" size="" name="Phones[Home]">
      <input :value="form.cellphone" type="text" size="" name="Phones[Cell]">
      <input :value="form.city" type="text" size="" name="City">
      <input :value="form.postalcode" type="text" name="PostalCode" size="" maxlength="">
      <input :value="form.methodOfContact" type="text" name="ContactPreference" size="">
      <input :value="lassoSourceTypeID" type="text" name="Questions[106381]">
      <input :value="lassoAgent" type="text" name="Questions[54084]">
      <input :value="form.agentname" type="text" name="Questions[52975]">
      <input type="hidden" name="SignupThankyouLink" value="https://mvpbarrie.com/thankyou/">
    </form>
  </b-container>
</template>

<script>
import jq from 'jquery'
export default {
  data() {
    return {
      form: {
        email: '',
        firstname: '',
        lastname: '',
        cellphone: '',
        homephone: '',
        city: '',
        postalcode: '',
        methodOfContact: null,
        howdidyouhearaboutus: null,
        agent: 'No',
        agentname: ''
      }
    }
  },
  computed: {
    lassoSourceTypeID() {
      if (this.form.howdidyouhearaboutus === 'A-frames/Signage') {
        return '295536'
      } else if (this.form.howdidyouhearaboutus === 'Billboard') {
        return '295537'
      } else if (this.form.howdidyouhearaboutus === 'E-mail') {
        return '295538'
      } else if (this.form.howdidyouhearaboutus === 'Fernbrook/MVP Website') {
        return '295539'
      } else if (this.form.howdidyouhearaboutus === 'Flyer') {
        return '295540'
      } else if (this.form.howdidyouhearaboutus === 'Friend') {
        return '295541'
      } else if (this.form.howdidyouhearaboutus === 'Google Ad') {
        return '295542'
      } else if (this.form.howdidyouhearaboutus === 'Newspaper/Magazine') {
        return '295543'
      } else if (this.form.howdidyouhearaboutus === 'Other') {
        return '295544'
      } else if (this.form.howdidyouhearaboutus === 'Realtor') {
        return '295545'
      } else if (this.form.howdidyouhearaboutus === 'Social Media') {
        return '295546'
      } else if (
        this.form.howdidyouhearaboutus === 'Tiffany Park Homes/MVP Website'
      ) {
        return '295547'
      } else if (this.form.howdidyouhearaboutus === 'Walk into a tent') {
        return '295548'
      }
      return false
    },
    lassoAgent() {
      if (this.form.agent === 'No') {
        return '227412'
      } else if (this.form.agent === 'Yes') {
        return '227411'
      }
      return false
    },
    formValidNoHttp() {
      if (
        this.emailCheckValid(this.form.email) &&
                this.httpCheckValid(this.form.firstname) &&
                this.httpCheckValid(this.form.lastname) &&
                this.httpCheckValid(this.form.cellphone) &&
                this.httpCheckValid(this.form.homephone) &&
                this.httpCheckValid(this.form.city) &&
                this.httpCheckValid(this.form.postalcode) &&
                this.httpCheckValid(this.form.methodOfContact) &&
                this.httpCheckValid(this.form.howdidyouhearaboutus) &&
                this.httpCheckValid(this.form.agent) &&
                this.httpCheckValid(this.form.agentname)
      ) {
        return true
      }
      return false
    }
  },
  mounted() {
    // jq('#lassoForm').on('click', () => {
    //   this.submitFormLasso()
    // })
  },
  methods: {
    hideModal() {
      this.$refs['register-modal'].hide()
    },
    emailRegExp(emailAddress) {
      const emailRegExpr = /^[0-9a-zA-Z_.-]+[@][0-9a-zA-Z_.-]+([.][a-zA-Z]+){1,2}$/
      return emailRegExpr.test(emailAddress)
    },
    noHttpRegExp(word) {
      const httpRegExpr = /(http:\/\/|https:\/\/|:\/\/)/i
      return !httpRegExpr.test(word)
    },
    emailCheckValid(email) {
      if (email !== '') {
        const valid = this.emailRegExp(email)
        return valid
      }
      return false
    },
    httpCheckValid(data) {
      if (data !== '') {
        const valid = this.noHttpRegExp(data)
        return valid
      }
      return true
    },
    submitFormLasso() {
      if (this.form.agent === 'No') {
        this.form.agentname = 'not agent'
      }
      /* eslint-disable no-debugger, no-console */
      console.log('submitting')
      const form = this.form
      console.log('Form Data:', form)
      console.log('Form Data:', form.email)
      const _this = this
      form.postalcode = form.postalcode.toUpperCase()
      jq.ajax({
        method: 'POST',
        url: '/php/registration-cm-lasso.php',
        // "https://staging.mywoodhaven.ca/addSubscriber_recaptcha_hubspot_vison2021.php",
        crossDomain: true,
        data: {
          email: form.email,
          firstname: form.firstname,
          lastname: form.lastname,
          cellphone: form.cellphone,
          homephone: form.homephone,
          city: form.city,
          postalcode: form.postalcode,
          methodOfContact: form.methodOfContact,
          hearus: form.howdidyouhearaboutus,
          agent: form.agent,
          agentname: form.agentname
        },
        success: function (data) {
          console.log("success:" + data)
          // const formkey = JSON.parse(data)

          const index1 = data.indexOf('"')
          const index2 = data.indexOf('"', index1 + 1)
          data = data.slice(index2 + 1)
          const formkey = JSON.parse(data)
          // formkey.formkey = formkey.formkey;
          // console.log(formkey)
          jq('input[name=domainAccountId]').val(formkey.formkey)
          jq('input[name=LassoUID]').val(formkey.formkeyLassoUID)
          jq('#lasso-registration-form').submit()
          jq('input[name=domainAccountId]').val('')
          jq('input[name=LassoUID]').val('')
        }
      }).done(function (msg) {

        // console.log('DONE: ' + msg)
        // console.log(msg)
        // jq('#lasso-registration-form').submit()
        // _this.$router.push({
        //   path: '/thankyou'
        // })
        // $("input[name=authenticity_token]").val("");
      })
    }
  }
}
</script>

<style>
.col-form-label {
    padding-left: 7px;
    font-size: 14px;
}
</style>
